module.exports = __webpack_public_path__ + "operace-ocnich-vicek-dolni_2_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-ocnich-vicek-dolni_2_before_tn.jpg
// module id = 1616
// module chunks = 0